import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import Translate from 'components/Translate';
import { useState } from 'react';
import RadioButton from 'components/UI/Radiobutton';
import { openSupport } from 'utils/openSupport';
import OtpModal from 'routes/Auth/components/OtpModal';
import { OTP_TYPES } from 'constants/global';
import StepHeader from './StepHeader';

const ClientExistsOTPValidation = ({
  literals,
  exists,
  onBack,
  onRequestOtp,
  onContinue,
  onEvent,
  headerStep,
  headerTotal,
}) => {
  const [type, setType] = useState(null);
  const { email, phone } = exists;
  const [showOtpModal, setShowOtpModal] = useState(false);

  const handleRequestOtp = () => {
    onRequestOtp(type).then((response) => {
      if (response) {
        setShowOtpModal(true);
      }
    });
  };

  return (
    <div className='full-screen-container'>
      <div className='screen-content'>
        <StepHeader step={headerStep} total={headerTotal} onEvent={onEvent} />
        <p className='font-bold text-primary mb-4 text-xl'>{literals.existsOTPValidation.verifyAccount}</p>
        {email || phone ? (
          <>
            <Translate literal={literals.existsOTPValidation.verifyAccountDescription} />
            <RadioButton
              className='mt-6'
              value={type}
              options={[
                email && { value: OTP_TYPES.EMAIL, label: `${literals.common.email}: ${email}` },
                phone && { value: OTP_TYPES.SMS, label: `${literals.common.phone}: ${phone}` },
              ].filter(Boolean)}
              onChange={setType}
            />
          </>
        ) : (
          <p className='mt-6'>{literals.existsOTPValidation.noData}</p>
        )}
      </div>
      <div className='screen-actions'>
        {email || phone ? (
          <Button onClick={handleRequestOtp} disabled={!type}>{literals.common.continue}</Button>
        ) : (
          <Button onClick={openSupport}>{literals.contactSupport}</Button>
        )}
        <Button type='outline-primary' onClick={onBack}>{literals.common.back}</Button>
      </div>
      {showOtpModal && (
        <OtpModal
          show
          onClose={() => setShowOtpModal(false)}
          otpType={type}
          onSubmit={onContinue}
        />
      )}
    </div>
  );
};

ClientExistsOTPValidation.propTypes = {
  literals: PropTypes.object.isRequired,
  exists: PropTypes.object.isRequired,
  onBack: PropTypes.func.isRequired,
  onRequestOtp: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  onEvent: PropTypes.func.isRequired,
  headerStep: PropTypes.number.isRequired,
  headerTotal: PropTypes.number.isRequired,
};

export default ClientExistsOTPValidation;
